module.exports = __webpack_public_path__ + "static/img/img-1.e227fd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-1.jpg
// module id = cnr1
// module chunks = 0